export const mapStatistics = (x) => {
    const provider = x.media &&
        x.media.find((mediaProvider) => mediaProvider.mediaType === "Stats" && mediaProvider.providerName === "BetRadarStats");
    x.statisticsEventId = provider ? provider.providerEventId : "";
    return x;
};
//# sourceMappingURL=mapStatistics.js.map